import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware'
import { storage } from './storage';
import { SectionData } from '../api-request/api-request';
import type { DynamicInputParameters } from '../types/ApiData';

//permentant storage
export interface StoredModels {
    [index: string]: SectionData;
}

export interface TaggedPoint  {
  id: string;            // stable point id
  edgeId: string;        // railwayEdgeId
  lng: number;
  lat: number;
  tags: string[];
  edgeName:string
  index: number
  isGeoPoint: boolean
};

type TaggedPoints = Record<string, TaggedPoint>;


export interface AppPermanentState {
    storedData: StoredModels,
    taggedPoints: TaggedPoints ,
    insertData: (params: DynamicInputParameters, data: SectionData, networkId: string) => void,
    deleteData: (params: DynamicInputParameters, fromHistory : boolean) => void,
    addTagToPoint: (tags:{edgeId: string,edgeName: string,index:number, lng:number,lat:number, tag: string, coordIndex: number, isGeoPoint: boolean}) => void
    deleteTaggedPoint: (id: string) => void
    deleteAllTags: () => void
}

export const useAppPermanentState = create<AppPermanentState>()(
    persist(
        (set) => ({
            storedData: {},
            taggedPoints: {},
            insertData: (params: DynamicInputParameters, data: SectionData, networkId: string) => {
                set((state) => {
                    const paramKey = JSON.stringify(params);
                    // Remove existing entry if params already exist
                    const filteredEntries = Object.entries(state.storedData).filter(([key]) => (key !== paramKey));

                    let newKey = { ...params, checked: true }
                    const newEntry = { [JSON.stringify(newKey)]: { ...data, checked: true } };

                    const updatedEntries = [
                        ...filteredEntries.map(([key, value]) => {
                            if (value.id === networkId) {
                                return [
                                    JSON.stringify({ ...JSON.parse(key), checked: false }),
                                    { ...value, checked: false }
                                ];
                            }

                            // keep unchanged
                            return [key, value];
                        }),
                        ...Object.entries(newEntry)
                    ].slice(-5);

                    const updatedStoredData = Object.fromEntries(updatedEntries);

                    return { storedData: updatedStoredData };
                });
            },
            deleteData: (params: DynamicInputParameters, fromHistory: boolean) => {
                set((state) => {
                    const models = state.storedData;
                    delete models[JSON.stringify(params)];
                    if (fromHistory) return { storedData: models }
                    else return { storedData: models }
                });
            },
            addTagToPoint: (tags:{edgeId: string,edgeName: string,index:number, lng:number,lat:number, tag: string, coordIndex: number, isGeoPoint: boolean}) => {
                const id = `${tags.edgeId}:${tags.lat}-${tags.lng}`;
                set(state => {
                    const existing = state.taggedPoints[id];

                    return {
                        taggedPoints: {
                            ...state.taggedPoints,
                            [id]: {
                                id,
                                edgeId: tags.edgeId,
                                lng: tags.lng,
                                lat: tags.lat,
                                edgeName: tags.edgeName,
                                index: tags.index,
                                isGeoPoint: tags.isGeoPoint,
                                tags: Array.from(
                                    new Set([...(existing?.tags ?? []), tags.tag])
                                )
                            }
                        }
                    };
                });
            },
            deleteTaggedPoint: (id: string) => {
                set(state => {
                    const { [id]: _, ...rest } = state.taggedPoints;
                    return { taggedPoints: rest };
                });
            },
            deleteAllTags: () => {
                set(() => {
                    return { taggedPoints: {} };
                });
            }
        }),
        {
            name: 'dynamic_perm_local_storage',
            storage: createJSONStorage(() => storage),
        },
    )
)




